// components/ArticleList.tsx
import React, { } from 'react';
import { Card } from '@mui/material';
import { TFunction } from 'next-i18next';
import { ChatObj } from '@/objects/Chat';
import ImageRound from '../../ImageRound';
import { black, gray, lightGray, primary, red, white, whiteSmoke } from '@/constants/Colors';
import { obtenerImagenes } from '@/util/Articulos';
import { mostrarAlerta, mostrarDialog } from '@/context/UtilsContext';
import ChatConversacion from '@/components/widgets/ChatConversacion';
import { dateToTextTForm, obtenerHoraTForm } from '@/util/MagicDate';
import Texto from '../../Texto';
import { textos, textosMini } from '@/constants/Dimens';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useServices } from '@/context/ServicesProvider';
import { LoginDatos } from '@/objects/User';
import { cargarDatosUsuario } from '@/util/LocalStorageLoaded';
import { AxiosResponse } from 'axios';
import { apellidoConPunto, primeraLetraMayuscula } from '@/util/StringsUtil';
import { filtarMoneda } from '@/util/Monedas';

interface Props {
  t: TFunction;
  chat: ChatObj;
  setChat: (chat: ChatObj) => void;
}

const RowChat: React.FC<Props> = ({ t, chat, setChat }) => {

  const { mensajesQueries } = useServices();

  //alert(JSON.stringify(chat));

  function abrirChat() {
    mostrarDialog({
      title: t('contenido:chat.chat_con', { nombre_usuario: apellidoConPunto(primeraLetraMayuscula(chat.nombre_otro_user)), titulo_libro: chat.title, precio: chat.prize, moneda: filtarMoneda(chat.moneda) }),
      children: <ChatConversacion
        id_chat={chat.id_chat}
        objChat={chat}
        t={t}
        updateLeido={() => {
          let updatedChat = { ...chat };
          updatedChat.leido = undefined;
          setChat(updatedChat);
        }}
      />
    });
  }

  return (
    <Card onClick={() => { chat.mostrar == 1 && abrirChat() }}
      style={{
        cursor: "pointer", display: 'flex', flexDirection: 'row',
        alignItems: 'center', justifyContent: 'space-between', width:
          window.innerWidth < 500 ? "94%" : "450px",
        backgroundColor: chat.mostrar == 1 ? white : whiteSmoke,
        color: chat.mostrar == 1 ? black : lightGray,
        padding: "20px",
      }}>
      <article style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: "100%" }}>
        <section style={{ position: 'relative', width: '20%' }}>
          <ImageRound
            src={obtenerImagenes(chat.imageArticle, "").image_preview}
            alt={t("menu:secciones.mensajes.imagen_articulo" + chat.title)}
            width={70}
            height={70}
            style={chat.mostrar == 0 ? { filter: 'grayscale(100%)' } : {}}
          />
          {chat.leido !== undefined && chat.leido > 0 &&
            <div style={{
              height: '25px', width: '25px', borderRadius: '50%', backgroundColor: red,
              color: white, position: 'absolute', top: -8, left: -8, display: 'flex', alignItems: 'center',
              justifyContent: 'center', fontSize: '12px'
            }}>
              {chat.leido > 99 ? '99+' : chat.leido}
            </div>
          }
        </section>
        <section style={{ display: 'flex', flexDirection: 'column', marginLeft: "10px", width: '52%' }}>
          <Texto>{t("contenido:chat.chat_con_usuario", { nombre_usuario: apellidoConPunto(primeraLetraMayuscula(chat.nombre_otro_user)) })}</Texto>
          <Texto color={chat.mostrar == 1 ? black : lightGray}>{chat.title}</Texto>
          <Texto color={chat.mostrar == 1 ? black : lightGray} fontSize={textosMini}>{dateToTextTForm(chat.fecha_mod, t) + " " + obtenerHoraTForm(chat.fecha)}</Texto>
        </section>
        <section style={{ display: 'flex', flexDirection: 'column', marginLeft: "10px", width: '15%' }}>
          <div>
            <Texto color={chat.mostrar == 1 ? black : gray} fontSize={textos}>{chat.prize + " " + filtarMoneda(chat.moneda)}</Texto>
          </div>
        </section>
        <section style={{ width: "8%" }}>
          {chat.mostrar == 1 &&
            <DeleteForeverIcon style={{ color: primary, cursor: 'pointer', height: "30px", width: "30px" }} onClick={(event) => {
              event.stopPropagation();
              mostrarAlerta({
                title: t('common:opciones.informacion'),
                content: t('contenido:chat.quieres_borrar_este_chat'),
                onAccept: () => {
                  //borrarConversacionChat(chat.id_user, chat.id_chat);
                  const datosUsuario: LoginDatos | null = cargarDatosUsuario();
                  mensajesQueries?.borrarConversacionChat(Number(datosUsuario?.id_user), chat.id_chat).then((response: AxiosResponse<number>) => {
                    chat.mostrar = 0;
                    setChat(chat);
                  }
                  ).catch((error: any) => {
                    console.log(error);
                  });
                },
                acceptText: t('contenido:chat.borrar'),
                showCancelButton: true,
              });
            }} />

          }
        </section>
      </article>
    </Card>
  );
};

export default RowChat;

